<mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
    <mat-label>Clasificación</mat-label>
    <select matInput matNativeControl formControlName="tipoVehiculo" [(ngModel)]="valorDefecto">
      <option label="--Seleccionar--"></option>
      <option value="00">0-CAMION</option>
      <option value="01">1-CAMION PLATAFORMA</option>
      <option value="02">2-CAMION CAJA</option>
      <option value="03">3-CAMION FURGON</option>
      <option value="04">4-CAMION BOTELLERO</option>
      <option value="05">5-CAMION CISTERNA</option>
      <option value="06">6-CAMION JAULA</option>
      <option value="07">7-CAMION FRIGORIFICO</option>
      <option value="08">8-CAMION TALLER</option>
      <option value="09">9-CAMION PARA CANTERA</option>
      <option value="0A">0A-CAMION PORTAVEHICULOS</option>
      <option value="0B">0B-CAMION MIXTO</option>
      <option value="0C">0C-CAMION PORTACONTENEDORES</option>
      <option value="0D">0D-CAMION BASURERO</option>
      <option value="0E">0E-CAMION ISOTERMO</option>
      <option value="0F">0F-CAMION SILO</option>
      <option value="0G">0G-VEHICULO MIXTO ADAPTABLE</option>
      <option value="10">10-CAMION ARTICULADO</option>
      <option value="11">11-CAMION ARTICULADO PLATAFORMA</option>
      <option value="12">12-CAMION ARTICULADO CAJA</option>
      <option value="13">13-CAMION ARTICULADO FURGON</option>
      <option value="14">14-CAMION ARTICULADO BOTELLERO</option>
      <option value="15">15-CAMION ARTICULADO CISTERNA</option>
      <option value="16">16-CAMION ARTICULADO JAULA</option>
      <option value="17">17-CAMION ARTICULADO FRIGORIFICO</option>
      <option value="18">18-CAMION ARTICULADO TALLER</option>
      <option value="19">19-CAMION ARTICULADO PARA CANTERA</option>
      <option value="1A">1A-CAMION ARTICULADO VIVIENDA O CARAVANA</option>
      <option value="1C">1C-CAMION ARTICULADO HORMIGONERA</option>
      <option value="1D">1D-CAMION ARTICULADO VOLQUETE</option>
      <option value="1E">1E-CAMION ARTICULADO GRUA</option>
      <option value="1F">1F-CAMION ARTICULADO CONTRA INCENDIOS</option>
      <option value="20">20-FURGONETA</option>
      <option value="21">21-FURGONETA MIXTA</option>
      <option value="22">22-AMBULANCIA</option>
      <option value="23">23-COCHE FUNEBRE</option>
      <option value="24">24-CAMIONETA</option>
      <option value="25">25-TODO TERRENO</option>
      <option value="30">30-AUTOBUS</option>
      <option value="31">31-AUTOBUS ARTICULADO</option>
      <option value="32">32-AUTOBUS MIXTO</option>
      <option value="40">40-TURISMO</option>
      <option value="50">50-MOTOCICLETA DE 2 RUEDAS SIN SIDECAR</option>
      <option value="51">51-MOTOCICLETA CON SIDECAR</option>
      <option value="52">52-MOTOCARRO</option>
      <option value="53">53-AUTOMOVIL DE 3 RUEDAS</option>
      <option value="54">54-CUATRICICLO</option>
      <option value="60">60-COCHE DE INVALIDO</option>
      <option value="70">70-VEHICULO ESPECIAL</option>
      <option value="71">71-PALA CARGADORA</option>
      <option value="72">72-PALA EXCAVADORA</option>
      <option value="73">73-CARRETILLA ELEVADORA</option>
      <option value="74">74-MOTONIVELADORA</option>
      <option value="75">75-COMPACTADORA</option>
      <option value="76">76-APISONADORA</option>
      <option value="77">77-GIROGRAVILLADORA</option>
      <option value="78">78-MACHACADORA</option>
      <option value="79">79-QUITANIEVES</option>
      <option value="7A">7A-VIVIENDA</option>
      <option value="7B">7B-BARREDORA</option>
      <option value="7C">7C-HORMIGONERA</option>
      <option value="7D">7D-VOLQUETE DE CANTERAS</option>
      <option value="7E">7E-GRUA</option>
      <option value="7F">7F-SERVICIO CONTRA INCENDIOS</option>
      <option value="7G">7G-ASPIRADORA DE FANGOS</option>
      <option value="7H">7H-MOTOCULTOR</option>
      <option value="7I">7I-MAQUINARIA AGRICOLA AUTOMOTRIZ</option>
      <option value="7J">7J-PALA CARGADORA-RETROEXCAVADORA</option>
      <option value="80">80-TRACTOR</option>
      <option value="81">81-TRACTOCAMION</option>
      <option value="82">82-TRACTOCARRO</option>
      <option value="90">90-CICLOMOTOR</option>
      <option value="91">91-VEHICULO DE 3 RUEDAS</option>
      <option value="92">92-CUADRICICLO LIGERO</option>
      <option value="R0">R0-REMOLQUE</option>
      <option value="R1">R1-REMOLQUE PLATAFORMA</option>
      <option value="R2">R2-REMOLQUE CAJA</option>
      <option value="R3">R3-REMOLQUE FURGON</option>
      <option value="R4">R4-REMOLQUE BOTELLERO</option>
      <option value="R5">R5-REMOLQUE CISTERNA</option>
      <option value="R6">R6-REMOLQUE JAULA</option>
      <option value="R7">R7-REMOLQUE FRIGORIFICO</option>
      <option value="R8">R8-REMOLQUE TALLER</option>
      <option value="R9">R9-REMOLQUE PARA CANTERAS</option>
      <option value="RA">RA-REMOLQUE VIVIENDA O CARAVANA</option>
      <option value="RB">RB-REMOLQUE DE VIAJEROS O DE AUTOBUS</option>
      <option value="RC">RC-REMOLQUE HORMIGONERA</option>
      <option value="RD">RD-REMOLQUE VOLQUETE DE CANTERA</option>
      <option value="RE">RE-REMOLQUE DE GRUA</option>
      <option value="RF">RF-REMOLQUE CONTRA INCENDIOS</option>
      <option value="RH">RH-MAQUINARIA AGRICOLA ARRASTRADA DE 2 EJES</option>
      <option value="S0">S0-SEMIRREMOLQUE</option>
      <option value="S1">S1-SEMIRREMOLQUE PLATAFORMA</option>
      <option value="S2">S2-SEMIRREMOLQUE CAJA</option>
      <option value="S3">S3-SEMIRREMOLQUE FURGON</option>
      <option value="S4">S4-SEMIRREMOLQUE BOTELLERO</option>
      <option value="S5">S5-SEMIRREMOLQUE CISTERNA</option>
      <option value="S6">S6-SEMIRREMOLQUE JAULA</option>
      <option value="S7">S7-SEMIRREMOLQUE FRIGORIFICO</option>
      <option value="S8">S8-SEMIRREMOLQUE TALLER</option>
      <option value="S9">S9-SEMIRREMOLQUE CANTERA</option>
      <option value="SA">SA-SEMIRREMOLQUE VIVIENDA O CARAVANA</option>
      <option value="SB">SB-SEMIRREMOLQUE VIAJEROS O AUTOBUS</option>
      <option value="SC">SC-SEMIRREMOLQUE HORMIGONERA</option>
      <option value="SD">SD-SEMIRREMOLQUE VOLQUETE DE CANTERA</option>
      <option value="SE">SE-SEMIRREMOLQUE GRUA</option>
      <option value="SF">SF-SEMIRREMOLQUE CONTRA INCENDIOS</option>
      <option value="SH">SH-MAQUINARIA AGRICOLA ARRASTRADA DE 1 EJE</option>
      <option value="98">98-PATINETE</option>
      <option value="99">99-BICICLETA</option>
    </select>
  </mat-form-field>
